export default __webpack_public_path__ + "static/low-complexity-5675fba184f559197feb76a86c6c5368a6e33a26ad815e099e3210373921222f.png";